import type { Event } from '@hedepy/common/schemas/modules/event/event'
import useSWR from 'swr'

import { type ApisType } from '@/legacy-src/store/createApis'

import { useApis } from '../contexts/api-context'
import { useSession } from '../contexts/session-context'

export type EventFetchType = 'all' | 'current'

const fetchFunction = async (api: ApisType['api'], type: EventFetchType): Promise<Event[]> => {
  const res = type === 'all' ? await api.getAllEvents() : await api.getCurrentEvents()
  return res.data
}

const useEvents = (type: EventFetchType = 'all') => {
  const { api } = useApis()
  const { isLoggedIn } = useSession()
  const { data, isLoading, mutate } = useSWR(isLoggedIn ? `useEvents-${type}` : null, () => fetchFunction(api, type))
  return { events: data, isLoading, refetchEvents: mutate }
}

export default useEvents
